import { enableProdMode, ErrorHandler, APP_ID, importProvidersFrom } from '@angular/core';
import {environment} from './environments/environment';
import { AppComponent } from './app/app.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { CurrencyPipe, registerLocaleData } from '@angular/common';
import * as localeNl from '@angular/common/locales/extra/nl';
import { UpdateUsersEffect } from './app/ngrx/effects/users/update-users-effect';
import { GetUsersEffect } from './app/ngrx/effects/users/get-users-effect';
import { UpdateModuleSubscriptionEffect } from './app/ngrx/effects/module-subscriptions/update-module-subscription-effect';
import { GetModuleSubscriptionsEffect } from './app/ngrx/effects/module-subscriptions/get-module-subscriptions-effect';
import { DeleteAnnouncementsEffect } from './app/ngrx/effects/announcements/delete-announcements-effect';
import { GetAnnouncementsEffect } from './app/ngrx/effects/announcements/get-announcements-effect';
import { DeleteChatsEffect } from './app/ngrx/effects/chats/delete-chats-effect';
import { GetChatsEffect } from './app/ngrx/effects/chats/get-chats-effect';
import { RemoveChecklistItemEffect } from './app/ngrx/effects/checklist-items/remove-checklist-item-effect';
import { GetChecklistItemsEffect } from './app/ngrx/effects/checklist-items/get-checklist-items-effect';
import { AddChecklistItemEffect } from './app/ngrx/effects/checklist-items/add-checklist-item-effect';
import { UpdateBijbEventEffect } from './app/ngrx/effects/bijb-event/update-bijb-event-effect';
import { GetBijbEventsEffect } from './app/ngrx/effects/bijb-event/get-bijb-events-effect';
import { GetBijbEventSuccessEffect } from './app/ngrx/effects/bijb-event/get-bijb-event-success-effect';
import { AddBijbEventEffect } from './app/ngrx/effects/bijb-event/add-bijb-event-effect';
import { GetBijbEventEffect } from './app/ngrx/effects/bijb-event/get-bijb-event-effect';
import { UpdateDressCodeEffect } from './app/ngrx/effects/dress-code/update-dress-code-effect';
import { GetDressCodeEffect } from './app/ngrx/effects/dress-code/get-dress-code-effect';
import { DeleteDressCodePictureEffect } from './app/ngrx/effects/dress-code-pictures/delete-dress-code-picture-effect';
import { GetDressCodePicturesEffect } from './app/ngrx/effects/dress-code-pictures/get-dress-code-pictures-effect';
import { AddDressCodePictureEffect } from './app/ngrx/effects/dress-code-pictures/add-dress-code-picture-effect';
import { UpdateEnclosureCardEffect } from './app/ngrx/effects/enclosure-cards/update-enclosure-card-effect';
import { GetEnclosureCardEffect } from './app/ngrx/effects/enclosure-cards/get-enclosure-card-effect';
import { DeleteGroupEffect } from './app/ngrx/effects/groups/delete-group-effect';
import { UpdateGroupEffect } from './app/ngrx/effects/groups/update-group-effect';
import { GetGroupsEffect } from './app/ngrx/effects/groups/get-groups-effect';
import { AddGroupEffect } from './app/ngrx/effects/groups/add-group-effect';
import { GetRsvpQuestionsEffect } from './app/ngrx/effects/rsvp-questions/get-rsvp-questions-effect';
import { LogoutEffect } from './app/ngrx/effects/logout/logout-effect';
import { LoginEffect } from './app/ngrx/effects/login/login-effect';
import { UpdateBijbAccountEffect } from './app/ngrx/effects/current-account/update-account-effect';
import { GetCurrentAccountEffect } from './app/ngrx/effects/current-account/get-current-account-effect';
import { GetCurrentUserEffect } from './app/ngrx/effects/current-user/get-current-user-effect';
import { provideEffects } from '@ngrx/effects';
import { UsersReducer } from './app/ngrx/reducers/users-reducer';
import { UsersState } from './app/ngrx/states/users-state';
import { RsvpQuestionsReducer } from './app/ngrx/reducers/rsvp-questions-reducer';
import { RsvpQuestionsState } from './app/ngrx/states/rsvp-questions-state';
import { ModuleSubscriptionsReducer } from './app/ngrx/reducers/module-subscriptions-reducer';
import { ModuleSubscriptionsState } from './app/ngrx/states/module-subscriptions-state';
import { LoginReducer } from './app/ngrx/reducers/login-reducer';
import { LoginState } from './app/ngrx/states/login-state';
import { GroupsReducer } from './app/ngrx/reducers/groups-reducer';
import { GroupsState } from './app/ngrx/states/groups-state';
import { EnclosureCardsReducer } from './app/ngrx/reducers/enclosure-cards-reducer';
import { EnclosureCardsState } from './app/ngrx/states/enclosure-cards-state';
import { DressCodeReducer } from './app/ngrx/reducers/dress-code-reducer';
import { DressCodeState } from './app/ngrx/states/dress-code-state';
import { DressCodePicturesReducer } from './app/ngrx/reducers/dress-code-pictures-reducer';
import { DressCodePicturesState } from './app/ngrx/states/dress-code-pictures-state';
import { CurrentAccountReducer } from './app/ngrx/reducers/current-account-reducer';
import { CurrentAccountState } from './app/ngrx/states/current-account-state';
import { CurrentUserReducer } from './app/ngrx/reducers/current-user-reducer';
import { CurrentUserState } from './app/ngrx/states/current-user-state';
import { ChecklistItemsReducer } from './app/ngrx/reducers/checklist-items-reducer';
import { ChecklistItemsState } from './app/ngrx/states/checklist-items-state';
import { ChatsReducer } from './app/ngrx/reducers/chats-reducer';
import { ChatsState } from './app/ngrx/states/chats-state';
import { BijbEventsReducer } from './app/ngrx/reducers/bijb-events-reducer';
import { BijbEventsState } from './app/ngrx/states/bijb-events-state';
import { BijbEventReducer } from './app/ngrx/reducers/bijb-event-reducer';
import { BijbEventState } from './app/ngrx/states/bijb-event-state';
import { AnnouncementsReducer } from './app/ngrx/reducers/announcements-reducer';
import { AnnouncementsState } from './app/ngrx/states/announcements-state';
import { provideState, provideStore } from '@ngrx/store';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { OwlMomentDateTimeModule } from '@danielmoncada/angular-datetime-picker-moment-adapter';
import { provideNgxStripe } from 'ngx-stripe';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { Routes } from './app/config/routes';
import { provideRouter, withNavigationErrorHandler } from '@angular/router';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { WindowProvider } from './app/helpers/window-provider';
import { Title, BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { RememberEventService } from './app/services/remember-event/remember-event.service';
import { GALLERY_CONFIG, GalleryConfig } from 'ng-gallery';
import { RollbarService, rollbarFactory } from './app/config/rollbar';
import { RollbarErrorHandler } from './app/helpers/rollbar-error-handler';
import { reloadOnChunkLoadError } from './app/helpers/chunk-load-error-handler';
import { OWL_DATE_TIME_LOCALE, OWL_DATE_TIME_FORMATS, OwlDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { NotLoggedInRouteGuard } from './app/helpers/route-guards/not-logged-in-route-guard';
import { LoggedInRouteGuard } from './app/helpers/route-guards/logged-in-route-guard';
import { GoogleAnalyticsService } from './app/services/google-analytics/google-analytics.service';
import { GiphyClient } from './app/services/giphy/giphy-client';
import { ErrorMessageService } from './app/services/error-message/error-message.service';
import { ApiService } from './app/services/api/api.service';
import { provideQuillConfig } from 'ngx-quill';

if (environment.name === 'production' || environment.name === 'acceptance') {
  enableProdMode();
}

registerLocaleData(localeNl, 'nl');

document.addEventListener('DOMContentLoaded', () => {
  bootstrapApplication(AppComponent, {
    providers: [
      importProvidersFrom(
        BrowserModule,
        NgxLoadingModule.forRoot({
          animationType: ngxLoadingAnimationTypes.threeBounce,
          fullscreenBackdrop: true,
          backdropBackgroundColour: 'rgba(0,0,0,0.6)',
          backdropBorderRadius: '0px',
          primaryColour: '#de5743',
          secondaryColour: '#FFC455',
          tertiaryColour: '#BCCCCB'
        }),
        OwlDateTimeModule,
        OwlMomentDateTimeModule,
        NgxSmartModalModule.forRoot(),
        UiSwitchModule.forRoot({
          size: 'small',
          color: '#de5743',
          switchColor: '#ffffff',
          defaultBgColor: '#bccccb',
          defaultBoColor: '#00000000',
          checkedLabel: '',
          uncheckedLabel: ''
        })
      ),
      ApiService,
      ErrorMessageService,
      GiphyClient,
      GoogleAnalyticsService,
      LoggedInRouteGuard,
      NotLoggedInRouteGuard,
      { provide: OWL_DATE_TIME_LOCALE, useValue: 'nl' },
      {
        provide: OWL_DATE_TIME_FORMATS, useValue: {
            parseInput: 'D MMMM YYYY HH:mm',
            fullPickerInput: 'D MMMM YYYY HH:mm',
            datePickerInput: 'D MMMM YYYY',
            timePickerInput: 'HH:mm',
            monthYearLabel: 'MMMM YYYY',
            dateA11yLabel: 'LL',
            monthYearA11yLabel: 'MMMM YYYY',
        }
      },
      { provide: ErrorHandler, useClass: RollbarErrorHandler },
      { provide: RollbarService, useFactory: rollbarFactory },
      { provide: APP_ID, useValue: 'serverApp' },
      {
        provide: GALLERY_CONFIG,
        useValue: {
            imageSize: 'contain',
            thumbImageSize: 'cover',
            counter: true,
            counterPosition: 'bottom',
            thumbs: true,
            loadingStrategy: 'lazy',
            loadingAttr: 'lazy'
        } as GalleryConfig
      },
      RememberEventService,
      Title,
      WindowProvider,
      provideAnimations(),
      provideEffects([
        GetCurrentUserEffect,
        GetCurrentAccountEffect,
        UpdateBijbAccountEffect,
        LoginEffect,
        LogoutEffect,
        GetRsvpQuestionsEffect,
        AddGroupEffect,
        GetGroupsEffect,
        UpdateGroupEffect,
        DeleteGroupEffect,
        GetEnclosureCardEffect,
        UpdateEnclosureCardEffect,
        AddDressCodePictureEffect,
        GetDressCodePicturesEffect,
        DeleteDressCodePictureEffect,
        GetDressCodeEffect,
        UpdateDressCodeEffect,
        GetBijbEventEffect,
        AddBijbEventEffect,
        GetBijbEventSuccessEffect,
        GetBijbEventsEffect,
        UpdateBijbEventEffect,
        AddChecklistItemEffect,
        GetChecklistItemsEffect,
        RemoveChecklistItemEffect,
        GetChatsEffect,
        DeleteChatsEffect,
        GetAnnouncementsEffect,
        DeleteAnnouncementsEffect,
        GetModuleSubscriptionsEffect,
        UpdateModuleSubscriptionEffect,
        GetUsersEffect,
        UpdateUsersEffect,
        CurrencyPipe
      ]),
      provideHttpClient(withInterceptorsFromDi()),
      provideNgxStripe(environment.stripeApiKeyPublishable),
      provideQuillConfig({
        placeholder: '',
        theme: 'snow',
      }),
      provideRouter(Routes, withNavigationErrorHandler(reloadOnChunkLoadError)),
      provideStoreDevtools({
        maxAge: 5,
        connectInZone: true}),
      provideStore(),
      provideState(AnnouncementsState.key, AnnouncementsReducer),
      provideState(BijbEventState.key, BijbEventReducer),
      provideState(BijbEventsState.key, BijbEventsReducer),
      provideState(ChatsState.key, ChatsReducer),
      provideState(ChecklistItemsState.key, ChecklistItemsReducer),
      provideState(CurrentUserState.key, CurrentUserReducer),
      provideState(CurrentAccountState.key, CurrentAccountReducer),
      provideState(DressCodePicturesState.key, DressCodePicturesReducer),
      provideState(DressCodeState.key, DressCodeReducer),
      provideState(EnclosureCardsState.key, EnclosureCardsReducer),
      provideState(GroupsState.key, GroupsReducer),
      provideState(LoginState.key, LoginReducer),
      provideState(ModuleSubscriptionsState.key, ModuleSubscriptionsReducer),
      provideState(RsvpQuestionsState.key, RsvpQuestionsReducer),
      provideState(UsersState.key, UsersReducer),
    ]
})
    .catch(err => console.log(err));
});
